import { render, staticRenderFns } from "./GeneralClientList.vue?vue&type=template&id=5ca622fa&lang=pug"
import script from "./GeneralClientList.vue?vue&type=script&lang=js"
export * from "./GeneralClientList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports